export class Timeout {
    private timeout;
    private remainingTime;
    private startedAt;
    private readonly callback;

    constructor(value: number, callback: () => void) {
        this.remainingTime = value;
        this.callback = callback;
        this.startedAt = Date.now();
        this.timeout = window.setTimeout(this.callback, this.remainingTime);
    }

    public resume = () => {
        this.timeout = window.setTimeout(this.callback, this.remainingTime);
        this.startedAt = Date.now();
    };

    public pause = () => {
        window.clearTimeout(this.timeout);
        this.remainingTime -= Date.now() - this.startedAt;
    };

    public remove = () => {
        window.clearTimeout(this.timeout);
    };
}
